import { isNumber } from './isNumber';

export const parseTaxTotal = (taxTotal: number | null | undefined) =>
  isNumber(taxTotal) ? taxTotal : 0;
